import { z } from 'zod';

export const InferenceServiceConfigDataSchema = z.object({
  max_loaded_models: z.number().int().min(1).default(3),
  preloaded_models: z.number().int().min(0).default(2),
});

export type InferenceServiceConfigData = z.infer<
  typeof InferenceServiceConfigDataSchema
>;
